// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const LensOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_5001)"},"children":[{"tag":"path","attrs":{"d":"M12 4a8.01 8.01 0 010 16 8.01 8.01 0 010-16zm0-2a10 10 0 100 20 10 10 0 000-20z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_5001"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"lens","theme":"outlined"};

const LensOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={LensOutlinedSvg} />;
  LensOutlined.displayName = 'LensOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(LensOutlined);
